import React, { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import { getContractDetail } from "./ContractHelper";
import {
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import { useOrganization } from "../../lib/context/OrganisationContext";

const ContractDetailsPopup = ({ contractId, showView, setShowView }) => {
  const { organizationData } = useOrganization();
  const [contractDetail, setContractDetail] = useState(null);
  const [contractLoading, setContractLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const contractDetailData = await getContractDetail(contractId, true);
      setContractDetail(contractDetailData);
      setContractLoading(false);
    }
    fetchData();
  }, [contractId, setContractDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={"Contract Details"}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      {contractLoading ? (
        <Spin full expand={true} />
      ) : (
        <div className="md:p-0 p-4">
          <div className="modal-content">
            <CardTitle className="text-md mb-2">Contract Details</CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>Agreement / Contract Number:</strong>{" "}
                {contractDetail?.contract_number
                  ? contractDetail?.contract_number
                  : "-"}
              </p>

              <p>
                <strong>Agreement / Contract Value:</strong>{" "}
                {contractDetail?.contract_value
                  ? formatNumber(Number(contractDetail?.contract_value))
                  : "-"}
              </p>
              <p>
                <strong>Agreement / Contract Value (Exc. GST):</strong>{" "}
                {contractDetail?.contract_value_exc
                  ? formatNumber(Number(contractDetail?.contract_value_exc))
                  : "-"}
              </p>

              {contractDetail?.contract_file && (
                <p>
                  <strong>Contract File:</strong>{" "}
                  <a
                    href={contractDetail.contract_file}
                    download
                    target="_blank"
                    className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                    rel="noreferrer"
                  >
                    Download
                  </a>
                </p>
              )}
              <p>
                <strong>Start Date:</strong>{" "}
                {contractDetail?.start_date ? contractDetail?.start_date : "-"}
              </p>
              <p>
                <strong>End Date:</strong>{" "}
                {contractDetail?.end_date ? contractDetail?.end_date : "-"}
              </p>
              <p>
                <strong>
                  {getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "vendors",
                    "Vendor"
                  )}
                  :
                </strong>{" "}
                {contractDetail?.vendor
                  ? formatSubcontractorName(contractDetail?.vendor)
                  : "-"}
              </p>
              <p>
                <strong>
                  {getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "assets",
                    "Asset"
                  )}
                  :
                </strong>{" "}
                {contractDetail?.asset?.name
                  ? contractDetail?.asset?.name
                  : "-"}
              </p>
              <p>
                <strong>
                  {getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "sub-assets",
                    "Sub Asset"
                  )}
                  :
                </strong>{" "}
                {contractDetail?.sub_asset?.name
                  ? contractDetail?.sub_asset?.name
                  : "-"}
              </p>
              <p>
                <strong>Auto Renewal:</strong>{" "}
                {contractDetail?.auto_renewal ? "Yes" : "No"}
              </p>
            </div>
          </div>
        </div>
      )}
    </ResponsiveDrawerForm>
  );
};

export default ContractDetailsPopup;
